import PDFPIL from "components/Images/PDFPIL.png"

export const PDFHeader = async ({ pdf, corporateData , headerImage }) => {
   const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 2
  const contentHeight = 22

  // **Draw Image First**
  pdf.addImage(PDFPIL, 'PNG', 10, 10, 20, 5)

  // // **Now Draw Vertical Line After Image**
  pdf.setDrawColor(245, 245, 245)
  pdf.setLineWidth(0.5)

  if (headerImage?.campusLogoRef) {
    const verticalLineX = 40
    const imageX = verticalLineX + 5
    pdf.line(verticalLineX, margin, verticalLineX, margin + contentHeight)

    const canvas = await html2canvas(headerImage?.campusLogoRef, {
      useCORS: true,
    })

    const preferredFormat = 'image/jpeg' // Change to "image/png" or "image/webp" if needed
    const imageData = canvas.toDataURL(preferredFormat, 1.0)
    const jsPDFFormat = preferredFormat.includes('jpeg') ? 'JPEG' : 'PNG'

    pdf.addImage(imageData, jsPDFFormat, imageX, 6, 150, 13)
  }
  else {
  const verticalLineX = 40
  const imageX = verticalLineX + 5

  pdf.line(verticalLineX, margin, verticalLineX, margin + contentHeight)

  // Add corporate logo
  if (corporateData?.logo) {
    const img = new Image()
    img.crossOrigin = "anonymous"
    img.src = corporateData.logo

    await new Promise(resolve => {
      img.onload = resolve
    })

    pdf.addImage(img, "PNG", imageX, 6, 12, 12)
  }
}

  const startX = 60 // Adjust as needed
  const maxWidth = 110

  const maxCharacters = 85 // Limit before adding "..."

  // Get the institute name and truncate if needed
  let campusName = corporateData?.name || ''

  if (campusName.length > maxCharacters) {
    campusName = campusName.substring(0, maxCharacters) + '...'
  }

  // Use splitTextToSize to wrap the (possibly truncated) text
  const wrappedText = pdf.splitTextToSize(campusName, maxWidth)

  // Calculate start Y position dynamically
  const startY = 10 // Adjust threshold as needed
  const totalLetters = wrappedText.reduce(
    (count, line) => count + line.length,
    0
  )
  // Calculate text height
  const textHeight = totalLetters > 40 ? 15 : 12

  // Add University Name
  pdf.setFont('helvetica', 'bold')

  pdf.setTextColor(60, 65, 70) // Lighter than (27, 31, 34)

  pdf.setFontSize(11)
  pdf.text(campusName, startX, startY, { maxWidth })

  // Add Location Below Wrapped Text
  const locationY = textHeight + 5 // Ensure spacing between wrapped text and location

  pdf.setFont('helvetica', 'normal')
  pdf.setTextColor(120, 125, 130) // Much lighter gray
  pdf.setFontSize(10)

  const locationArray = [
    corporateData?.city,
    corporateData?.state,
  ].filter(Boolean)
  const locationText = locationArray.join(', ')

  pdf.text(locationText, startX, locationY)

  pdf.setTextColor(60, 65, 70)

  // Draw a full-page border
  pdf.setDrawColor(245, 245, 245) // Gray color
  pdf.setLineWidth(8) // Border thickness
  pdf.rect(5, 31, pageWidth - 10, pageHeight - 36)

  return 50
}

























//   // 🔹 Logo (Left)
//   pdf.addImage(PDFPIL, "PNG", 10, 8, 25, 8)

//   // 🔹 Title (Center)
//   pdf.setFont("helvetica", "bold")
//   pdf.setFontSize(14)
//   pdf.setTextColor(40, 40, 40)

//   pdf.text("Corporate Dashboard Report", pageWidth / 2, 12, {
//     align: "center",
//   })

//   // 🔹 Date (Right)
//   pdf.setFont("helvetica", "normal")
//   pdf.setFontSize(10)

//   const date = new Date().toLocaleDateString()
//   pdf.text(date, pageWidth - 10, 12, { align: "right" })

//   // 🔹 Divider line
//   pdf.setDrawColor(220, 220, 220)
//   pdf.line(10, 18, pageWidth - 10, 18)

//   return 25 // 🔥 starting Y position
// }